import React from 'react';
import { featuresContent } from './Features.content';
import styles from './Features.module.sass';
import { Container } from '../ui/Container';
import cloud from './assets/cloud-1.webp';
import cloud2 from './assets/cloud-2.webp';

export function Features () {

  return (
    <section className={styles.features}>
      <Container className={styles.features__body}>
        <div className={styles.features__top}>
          <div className={styles.features__title}
              dangerouslySetInnerHTML={{ __html: featuresContent.titleTop }}
          />
          <div className={styles.features__text}
            dangerouslySetInnerHTML={{ __html: featuresContent.textTop }}
          />
        </div>

        <div className={styles.features__block}>
          {featuresContent.featuresTopBlock.map((item, i) => (
            <div key={i} className={styles.features__item}>
              <img src={item.image} alt="" className={styles.features__image} />
              <div className={styles.features__itemTitle}
                dangerouslySetInnerHTML={{ __html: item.itemTitle }}
              />
             <div className={styles.features__itemText}
                dangerouslySetInnerHTML={{ __html: item.itemText }}
              />
            </div>
          ))}
        </div>

        <div className={styles.features__bottom}>
          <div className={styles.features__title}
              dangerouslySetInnerHTML={{ __html: featuresContent.titleBottom }}
          />
          <div className={styles.features__text}
            dangerouslySetInnerHTML={{ __html: featuresContent.textBottom }}
          />
        </div>

        <div className={styles.features__blockBottom}>
          {featuresContent.featuresBottomBlock.map((item, i) => (
            <div key={i} className={styles.features__item}>
              <img src={item.image} alt="" className={styles.features__image} />
              <div className={styles.features__itemTitle}
                dangerouslySetInnerHTML={{ __html: item.itemTitle }}
              />
             <div className={styles.features__itemText}
                dangerouslySetInnerHTML={{ __html: item.itemText }}
              />
            </div>
          ))}
        </div>
      </Container>
      <img src={cloud} alt="Облако" className={styles['features__cloud-1']} />
      <img src={cloud2} alt="Облако" className={styles['features__cloud-2']} />
    </section>
  );
}
